/* Mobil menu drawer'inda section-fetcher tetiklenmedigi durumlarda manuel yukle */
(function () {
  function loadDrawerMenu() {
    var drawer = document.getElementById("Drawer-Menu");
    if (!drawer) return;
    var fetcher = drawer.querySelector("section-fetcher");
    if (!fetcher) return;
    var sid = fetcher.getAttribute("data-section-id");
    var tid = fetcher.getAttribute("data-target-id");
    var target = tid ? document.getElementById(tid) : null;
    if (!target) return;
    if (target.dataset.gvLoaded === "1") return;
    if (target.querySelector("a")) {
      target.dataset.gvLoaded = "1";
      return;
    }
    target.dataset.gvLoading = "1";
    fetch("/?section_id=" + encodeURIComponent(sid))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var src = tmp.querySelector("#" + CSS.escape(tid));
        if (src) {
          target.innerHTML = src.innerHTML;
        } else {
          var root = tmp.querySelector("#shopify-section-" + sid) || tmp;
          target.innerHTML = root.innerHTML;
        }
        target.querySelectorAll("script").forEach(function (oldS) {
          var s = document.createElement("script");
          for (var i = 0; i < oldS.attributes.length; i++) {
            var a = oldS.attributes[i];
            s.setAttribute(a.name, a.value);
          }
          s.textContent = oldS.textContent;
          oldS.parentNode.replaceChild(s, oldS);
        });
        target.dataset.gvLoaded = "1";
        target.dataset.gvLoading = "0";
      })
      .catch(function () { target.dataset.gvLoading = "0"; });
  }

  function bindOpeners() {
    document.querySelectorAll(
      "side-drawer-opener.header__icon--menu, .header__icon--menu, [aria-controls='Drawer-Menu']"
    ).forEach(function (el) {
      if (el.dataset.gvBound === "1") return;
      el.dataset.gvBound = "1";
      el.addEventListener("click", function () { setTimeout(loadDrawerMenu, 30); }, { passive: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindOpeners);
  } else {
    bindOpeners();
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest("side-drawer-opener.header__icon--menu, .header__icon--menu, [aria-controls='Drawer-Menu']");
    if (t) setTimeout(loadDrawerMenu, 30);
  });
})();
